import { lazy, Suspense } from 'react';

import { Switch } from 'react-router-dom';

import { RoleName } from '@m/types/api/iam/Iam';
import { ListPageWrapper } from 'apps/admin/AdminApp.styled';
import AuthenticatedRoute from 'apps/admin/components/AuthenticatedRoute';

const EventsListContainer = lazy(() => import('apps/admin/containers/Events/EventsListContainer'));

export const eventsRoutesConfig = [
  {
    exact: true,
    path: '/events',
    breadcrumb: 'Events',
    roles: [
      RoleName.SUPER_ADMIN,
      RoleName.LEADER,
      RoleName.OPERATIONAL_ADMIN,
      RoleName.CUSTOMER_SUPPORT,
      RoleName.MANAGER,
    ],
    component: AuthenticatedRoute,
    children: (
      <Suspense fallback={null}>
        <ListPageWrapper>
          <EventsListContainer />
        </ListPageWrapper>
      </Suspense>
    ),
  },
];

export default function EventsRoutes() {
  return (
    <Switch>
      {eventsRoutesConfig.map(
        ({ component: Component, breadcrumb, ...props }) =>
          Component && <Component key={props.path} {...props} />,
      )}
    </Switch>
  );
}
